
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSubscriptionsStatus } from './useSubscriptionsStatus';
import { useSubscriptionActions } from './useSubscriptionActions';
import { useSubscriptionsFiltering } from './useSubscriptionsFiltering';
import { useSubscriptionDetails } from './useSubscriptionDetails';
import { toast } from '@/components/ui/sonner';

export const useSubscriptionsData = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [subscriptionsCount, setSubscriptionsCount] = useState<number | null>(null);
  
  const { 
    subscriptions: allSubscriptions, 
    loading, 
    error,
    fetchData 
  } = useSubscriptionsStatus(setSubscriptionsCount);
  
  const {
    statusFilter,
    courierFilter,
    handleStatusChange,
    handleCourierChange,
    handleClearFilter
  } = useSubscriptionsFiltering(searchParams, setSearchParams);
  
  const {
    selectedSubscription,
    showDetailsDialog,
    handleViewSubscription,
    handleCloseDialog
  } = useSubscriptionDetails(searchParams, setSearchParams);
  
  const {
    actionLoading,
    isEditMode,
    handleStatusUpdate,
    handleDeleteSubscription,
    handleEditSubscription,
    handleCloseEditMode
  } = useSubscriptionActions(fetchData, handleCloseDialog, selectedSubscription);
  
  // Фильтрация подписок на основе выбранных фильтров
  const filteredSubscriptions = allSubscriptions.filter(sub => {
    // Фильтр по статусу
    const statusMatch = !statusFilter || sub.status === statusFilter;
    
    // Фильтр по курьеру - проверка на все возможные структуры данных
    let courierMatch = true;
    if (courierFilter) {
      const courierId = sub.courierId ||
                        (sub.rentals?.courier_id) ||
                        (sub.rentals?.courier?.id);
      courierMatch = courierId === courierFilter;
    }
    
    return statusMatch && courierMatch;
  });
  
  // Загрузка данных при изменении фильтров или компонента
  useEffect(() => {
    console.log('Загружаем данные подписок');
    fetchData();
  }, [fetchData]);

  // Уведомление об обновлении данных подписок
  useEffect(() => {
    if (allSubscriptions.length > 0 && !loading) {
      toast.info('Данные подписок', {
        description: `Загружено ${allSubscriptions.length} подписок`,
      });
    }
  }, [allSubscriptions, loading]);

  return {
    // Возвращаем отфильтрованные подписки вместо всех
    subscriptions: filteredSubscriptions,
    loading,
    error,
    statusFilter,
    courierFilter,
    selectedSubscription,
    showDetailsDialog,
    actionLoading,
    isEditMode,
    subscriptionsCount,
    fetchData,
    handleStatusChange,
    handleCourierChange,
    handleClearFilter,
    handleViewSubscription,
    handleCloseDialog,
    handleStatusUpdate,
    handleDeleteSubscription,
    handleEditSubscription,
    handleCloseEditMode
  };
};
